import React, { useState } from 'react';
import axios from 'axios';

const EditInvitationTypeForm = ({ onClose, onUpdated, typeToEdit }) => {
  const [name, setName] = useState(typeToEdit.name || '');
  const [saving, setSaving] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_URL}/ems/invitation-types/${typeToEdit._id}`, { name });
      alert('Invitation type updated successfully', 'success');
      onUpdated();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Failed to update invitation type';
      alert(msg, 'danger');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Invitation Type</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Invitation Type</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-warning" disabled={saving}>
                {saving ? 'Saving…' : 'Save Changes'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditInvitationTypeForm;
